import styled from 'styled-components';

export const LoaderContainer = styled.div`
  position: fixed;
  display: flex;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 10000;
  justify-content: center;
  align-items: center;
  backdrop-filter: brightness(0.8);

  img {
    border-radius: 50%;
    width: 60px;
    height: 60px;
  }
`;
